/** 激励广告运营契约：完整配置、语言覆盖及不可变单元版本登记。 */
import { z } from 'zod';

export const RewardedAdConfigSchema = z.strictObject({
  bonus_reward: z
    .number({ error: '请填写整数' })
    .int('请填写整数')
    .min(1, '奖励须为 1–100')
    .max(100, '奖励须为 1–100'),
  task_daily_limit: z
    .number({ error: '请填写整数' })
    .int('请填写整数')
    .min(0, '须为 0–10 的整数')
    .max(10, '须为 0–10 的整数'),
  chapter_daily_limit: z
    .number({ error: '请填写整数' })
    .int('请填写整数')
    .min(0, '须为 0–10 的整数')
    .max(10, '须为 0–10 的整数'),
  registration_day_threshold: z
    .number({ error: '请填写整数' })
    .int('请填写整数')
    .min(0, '须为 0–10 的整数')
    .max(10, '须为 0–10 的整数'),
});
export type RewardedAdConfig = z.infer<typeof RewardedAdConfigSchema>;
export const DEFAULT_REWARDED_AD_CONFIG: Readonly<RewardedAdConfig> = {
  bonus_reward: 15,
  task_daily_limit: 5,
  chapter_daily_limit: 2,
  registration_day_threshold: 2,
};

export const RewardedAdPlacementSchema = z.enum(['TASK_CENTER', 'CHAPTER_UNLOCK']);
export type RewardedAdPlacement = z.infer<typeof RewardedAdPlacementSchema>;
export const UpsertRewardedAdLanguageConfigRequestSchema = z.strictObject({
  config: RewardedAdConfigSchema,
});
export const UpsertRewardedAdUnitRequestSchema = z
  .strictObject({
    ad_unit_id: z
      .string()
      .max(255)
      .regex(/^ca-app-pub-[0-9]+\/[0-9]+$/),
    ssv_ad_unit_id: z
      .string()
      .max(255)
      .regex(/^[0-9]+$/),
  })
  .superRefine((value, context) => {
    // SSV 使用完整单元 ID 的末段；不接受会改变同一性判断的任意映射。
    if (value.ad_unit_id.split('/')[1] !== value.ssv_ad_unit_id) {
      context.addIssue({
        code: 'custom',
        path: ['ssv_ad_unit_id'],
        message: 'SSV 数值单元 ID 必须与完整 ID 的末段完全一致',
      });
    }
  });
export type UpsertRewardedAdUnitRequest = z.infer<typeof UpsertRewardedAdUnitRequestSchema>;

export type RewardedAdLanguageConfigResponse = {
  language: string;
  config: RewardedAdConfig;
  created_at: string;
  updated_at: string;
};
export type RewardedAdUnitResponse = {
  id: string;
  platform: 'IOS' | 'ANDROID';
  placement: RewardedAdPlacement;
  ad_unit_id: string;
  ssv_ad_unit_id: string;
  created_at: string;
};
